// @ts-check

/**
 * @enum {number}
 * @private
 */
const GeometryType = {
  NONE: 0,
  TRIANGLES: 1,
  LINES: 2,
  POLYLINES: 3,
};

Object.freeze(GeometryType);

export default GeometryType;
